import { format } from 'd3-format';

import './styles/graphic.scss';
import { classify } from './utils/helpers';

export default function (props, container, isMobile) {
  const {
    data,
    initialWidth,
    initialHeight,
    width,
    height,
    x,
    y,
    xAxis,
    yAxis,
    margins,
  } = props;

  const yTicks = isMobile ? 5 : 5;
  const fmtComma = format(',');
  const fmtSI = format('.2s');

  const ticksMobi = ['2008-01-05', '2010-01-02', '2012-01-07', '2014-01-04', '2016-01-02', '2018-01-06', '2020-01-04'];
  const ticksDesk = ['2007-01-06', '2008-01-05', '2009-01-03', '2010-01-02', '2011-01-01', '2012-01-07', '2013-01-05', '2014-01-04', '2015-01-03', '2016-01-02', '2017-01-07', '2018-01-06', '2019-01-05', '2020-01-04'];

  /** SET WEEKLY * */
  const selectedDate = '2020-03-28';
  const selectText = '6,648,000 claims';

  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', initialHeight);

  const g = svg.append('g')
    .attr('transform', `translate(${[margins.left, margins.top]})`);

  const xGrid = g.append('g')
    .attr('class', 'x grid')
    .attr('transform', `translate(${[0, height]})`)
    .call(xAxis(x)
      .tickValues(isMobile ? ticksMobi : ticksDesk)
      .tickFormat(d => (isMobile ? `\u0027${String(d).substring(2, 4)}` : `\u0027${String(d).substring(2, 4)}`)));

  xGrid.selectAll('text')
    .attr('y', 10);

  const yGrid = g.append('g')
    .attr('class', 'y grid')
    .call(yAxis(y)
      .ticks(yTicks)
      .tickSize(-width)
      .tickFormat(d => (isMobile
        ? (Math.abs(d) > 999
          ? fmtSI(d).toUpperCase()
          : fmtComma(d)
        )
        : (Math.abs(d) > 9999
          ? fmtSI(d).toUpperCase()
          : fmtComma(d)
        ))));

  yGrid.selectAll('text')
    .attr('x', -5)
    .filter(d => d === 0)
    .remove(); // hide zero

  const group = g.append('g')
    .attr('class', 'data');

  const recessions = group.append('g')
    .attr('class', 'recessions');

  const bars = group.append('g')
    .attr('class', 'bars');

  const labels = group.append('g')
    .attr('class', 'labels');

  const recession = recessions.append('rect')
    .attr('class', 'recession')
    .attr('transform', `translate(${[x('2007-12-01'), 0]})`)
    .attr('width', x('2009-06-06') - x('2007-12-01'))
    .attr('height', height)
    .style('fill', 'grey')
    .style('fill-opacity', 0.09);

  const bar = bars.selectAll('.bar')
    .data(data)
    .enter().append('g')
    .attr('class', 'bar')
    .attr('role', 'list')
    .attr('transform', d => (isMobile
      ? d.label === '2020-03-14'
        ? `translate(${[x(d.label) + 1, y(d.amt < 0 ? 0 : d.amt)]})`
        : d.label === '2020-03-21'
          ? `translate(${[x(d.label) + 5, y(d.amt < 0 ? 0 : d.amt)]})`
          : d.label === '2020-03-28'
            ? `translate(${[x(d.label) + 8, y(d.amt < 0 ? 0 : d.amt)]})`
            : `translate(${[x(d.label) + 0, y(d.amt < 0 ? 0 : d.amt)]})`
      : d.label === '2020-03-14'
        ? `translate(${[x(d.label) + 1, y(d.amt < 0 ? 0 : d.amt)]})`
        : d.label === '2020-03-21'
          ? `translate(${[x(d.label) + 4, y(d.amt < 0 ? 0 : d.amt)]})`
          : d.label === '2020-03-28'
            ? `translate(${[x(d.label) + 7, y(d.amt < 0 ? 0 : d.amt)]})`
            : `translate(${[x(d.label) + 0, y(d.amt < 0 ? 0 : d.amt)]})`
    ));

  bar.append('title')
    .text(d => `${d.label} (${d.amt})`);

  bar.append('rect')
    .attr('class', d => (d.label === selectedDate ? `data-new-${classify(d.label)}` : `data-${d.label}`))
    .attr('width', d => (d.label === selectedDate || d.label === '2020-03-21' || d.label === '2020-03-14' ? 3 : x.bandwidth()))
    .attr('height', d => Math.abs(y(d.amt) - y(0)));

  // labels.append('circle')
  //  .attr('class', 'label-2020-circle')
  //  .attr('transform', (isMobile ? `translate(${[x(selectedDate) + 0.75, y(data[data.length - 1].amt)]})` : `translate(${[x(selectedDate) + 1.5, y(data[data.length - 1].amt)]})`))
  //  .attr('cx', 0)
  //  .attr('cy', 0)
  //  .attr('r', 2);

  // labels.append('circle')
  //  .attr('class', 'label-2020-circle')
  //  .attr('transform', (isMobile ? `translate(${[x('2020-03-21') + 0.85, y(data[data.length - 2].amt)]})` : `translate(${[x('2020-03-21') + 0.75, y(data[data.length - 2].amt)]})`))
  //  .attr('cx', 0)
  //  .attr('cy', 0)
  //  .attr('r', 2);

  labels.append('text')
    .attr('class', 'label-recession')
    .attr('transform', `translate(${[x('2007-12-01') + 5, 15]})`)
    .attr('text-anchor', 'start')
    .text('The Great Recession');

  labels.append('text')
    .attr('class', 'label-2020')
    .attr('transform', `translate(${[x(selectedDate) + 3, y(data[data.length - 1].amt)]})`)
    .attr('text-anchor', 'end')
    .text(selectText)
    .append('tspan')
    .text('March 28')
    .attr('x', 0)
    .attr('dy', +14);

  labels.append('text')
    .attr('class', 'label-2020')
    .attr('transform', `translate(${[x('2020-03-21') - 1, y(data[data.length - 2].amt)]})`)
    .attr('text-anchor', 'end')
    .text('3,307,000 claims')
    .append('tspan')
    .text('March 21')
    .attr('x', 0)
    .attr('dy', +14);

  labels.append('text')
    .attr('class', 'label-2009')
    .attr('transform', `translate(${[x('2009-03-28'), y(665000) - 20]})`)
    .attr('text-anchor', 'start')
    .text('665,000')
    .append('tspan')
    .text('March 28, 2009')
    .attr('x', 0)
    .attr('dy', +14);

  // bar.append('text')
  //  .attr('class', 'value in')
  //  .attr('role', 'listitem')
  //  .attr('x', x.bandwidth() / 2)
  //  .attr('dy', d => ((d.amt > y.domain()[1] * 0.9)
  //    ? '1.1em'
  //    : '-.15em'))
  //  .attr('text-anchor', 'middle')
  //  .text(d => (isMobile
  //    ? (Math.abs(d.amt) > 999
  //      ? fmtSI(d.amt).toUpperCase()
  //      : fmtComma(d.amt)
  //    )
  //    : (Math.abs(d.amt) > 9999
  //      ? fmtSI(d.amt).toUpperCase()
  //      : fmtComma(d.amt)
  //    )));

  if (y.domain()[0] < 0) {
    // zero line
    g.append('line')
      .attr('role', 'presentation')
      .attr('class', 'zero-bar')
      .attr('x1', 0)
      .attr('x2', width)
      .attr('y1', y(0))
      .attr('y2', y(0));
  }
}
